export default function initVideoMod() {

	const WHOLE_DIV_PLAYBTN = true;
	const videoDivs = new Array();

	const init = () => {
		initMefaVideo();
	}

	const initMefaVideo = () => {
		const mefaVideo = document.querySelectorAll('.mefa-video');

		// resize bottom accent height //
		mefaVideo.forEach(video => {
			const background = video.querySelector('.video-background');
			const backgroundBot = background.querySelector('.bottom');
			const videoDiv = video.querySelector('.video');
			let plyBtn = (WHOLE_DIV_PLAYBTN) ? video.querySelector('.video-details') : video.querySelector('.play-video');

			// play btn funcationality //
			plyBtn.addEventListener('click', event => {

				if (videoDiv !== null) {
					const player = videoDiv.querySelector('iframe');
					//no player means its a link to a video page
					if(player){
						videoDiv.style.display = 'block';
						event.preventDefault();
						const videoPlayer = new URL( player.dataset.src ? player.dataset.src : player.src );
						videoPlayer.searchParams.set('autoplay', '1');
						player.src = videoPlayer.toString();

						let playerFound = false;
						for( let i = 0 ; i < videoDivs.length ; i++ ) {
							if (videoDivs[i] == videoDiv ) {
								playerFound = true;
							} else {
								const playeriframe = videoDivs[i].querySelector('iframe');
								playeriframe.dataset.src = playeriframe.src;
								playeriframe.src = '';
								videoDivs[i].style.display = 'none';
							}
						}
						if (!playerFound) videoDivs.push(videoDiv);
					}
				}
			});


			const resizeBackground = () => {
				const bottom = video.querySelector('.video-background .bottom');
				const leftBottom = video.querySelector('.content-left .bottom');
				bottom.style.height = leftBottom.offsetHeight + 'px';
			}

			if (background && backgroundBot) {
				window.addEventListener('resize', resizeBackground);
				resizeBackground();
			}
		});
	}



	init();
}

